import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function putJobeditJobDetails(
  params: openapi.JobeditCustomerDetailsQueryOpenapi,
  data: openapi.JobeditCustomerDetailsBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<void> {
  return await api.put('/jobedit/job-details/', data, {
    ...requestConfig,
    params,
  });
}

export async function putJobeditProducts(
  params: openapi.JobeditProductsQueryOpenapi,
  data: openapi.JobeditProductsBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.JobeditProductsContentOpenapi> {
  return await api.put('/jobedit/products/', data, {
    ...requestConfig,
    params,
  });
}

export async function putJobeditServices(
  params: openapi.JobeditServicesQueryOpenapi,
  data: openapi.JobeditServicesBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.JobeditServicesContentOpenapi> {
  return await api.put('/jobedit/services/', data, {
    ...requestConfig,
    params,
  });
}

export async function putJobeditStopContentSection(
  params: openapi.PutJobeditStopContentSection_Query,
  data: openapi.PutJobeditStopContentSection_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PutJobeditStopContentSection_201> {
  return await api.put('/jobedit/stop-content-section/', data, {
    ...requestConfig,
    params,
  });
}

export async function postJobeditStop(
  params: openapi.JobeditAddThirdStopQueryOpenapi,
  data: openapi.JobeditAddThirdStopBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.JobeditAddThirdStopContentOpenapi> {
  return await api.post('/jobedit/stop/', data, {
    ...requestConfig,
    params,
  });
}

export async function putJobeditStop(
  params: openapi.JobeditStopDetailsQueryOpenapi,
  data: openapi.JobeditStopDetailsBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.JobeditStopDetailsContentOpenapi> {
  return await api.put('/jobedit/stop/', data, {
    ...requestConfig,
    params,
  });
}

export async function putJobeditStopSection(
  params: openapi.PutJobeditStopSection_Query,
  data: openapi.PutJobeditStopSection_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PutJobeditStopSection_201> {
  return await api.put('/jobedit/stop-section/', data, {
    ...requestConfig,
    params,
  });
}

export async function deleteJobeditStop(
  params: openapi.JobeditStopDeleteQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<void> {
  return await api.delete('/jobedit/stop/', {
    ...requestConfig,
    params,
  });
}

export async function getJobeditJob(
  params: openapi.JobeditGetJobQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.JobeditGetJobContentOpenapi> {
  return await api.get('/jobedit/job/', {
    ...requestConfig,
    params,
  });
}

export async function postJobeditLock(
  params: openapi.JobeditLockQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.JobeditLockContentOpenapi> {
  return await api.post('/jobedit/lock/', null, {
    ...requestConfig,
    params,
  });
}

export async function postJobeditUnlock(
  params: openapi.JobeditUnlockQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<void> {
  return await api.post('/jobedit/unlock/', null, {
    ...requestConfig,
    params,
  });
}

export async function postJobeditCancel(
  params: openapi.JobeditCancelQueryOpenapi,
  data: openapi.JobeditCancelBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<void> {
  return await api.post('/jobedit/cancel/', data, {
    ...requestConfig,
    params,
  });
}

export async function postJobeditFutile(
  params: openapi.JobeditFutileQueryOpenapi,
  data: openapi.JobeditFutileBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<void> {
  return await api.post('/jobedit/futile/', data, {
    ...requestConfig,
    params,
  });
}

export async function postJobeditAllocation(
  params: openapi.PostJobeditAllocation_Query,
  data: openapi.PostJobeditAllocation_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<void> {
  return await api.post('/jobedit/allocation/', data, {
    ...requestConfig,
    params,
  });
}
